import React from "react";
import Select from "react-select";
import { cn } from "utils/cn";

const SelectComponent = ({
  options,
  value,
  label,
  name,
  onChange,
  placeholder,
  error,
  errorMsg,
  labelClassName,
  className,
  disabled = false,
  isClearable = true,
  multiSelect = false,
  isSearchable = false,
  hideSelectedOptions = false,
  isRequired = true,
  dataChoices,
  defaultValue,
  onBlur,
}) => {
  let valueArray = [];
  if (multiSelect) {
    value?.forEach((val) => {
      valueArray?.push(options?.find((option) => option?.value === val));
    });
  }

  return (
    <div className={cn(className)}>
      {typeof label === "string" ? (
        <>
          <label
            htmlFor={name}
            className={cn("font-normal text-[14px] mb-1", labelClassName)}
          >
            {label} {isRequired && <span className="text-[#FF5C5C]">*</span>}
          </label>
          <br />
        </>
      ) : (
        label
      )}

      <Select
        isMulti={multiSelect}
        isClearable={isClearable}
        data-choices={dataChoices}
        isDisabled={disabled}
        isSearchable={isSearchable}
        defaultValue={defaultValue}
        hideSelectedOptions={hideSelectedOptions}
        name={name}
        placeholder={placeholder}
        options={options}
        value={
          multiSelect
            ? valueArray
            : options?.find((option) => option?.value === value)
        }
        onChange={onChange}
        onBlur={onBlur}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          control: (provided, state) => ({
            ...provided,
            borderRadius: "0.375rem",
            borderColor: error
              ? "#EF4444"
              : state.isFocused
                ? "#CBD5E1"
                : "#E2E8F0",
            boxShadow: state.isFocused
              ? "0 0 0 3px rgba(203,213,225,0.3)"
              : "none",
            backgroundColor: "#ffffff",
            cursor: disabled ? "not-allowed" : "default",
            transition: "border-color 0.2s, box-shadow 0.2s",
            "&:hover": {
              borderColor: error
                ? "#EF4444"
                : state.isFocused
                  ? "#CBD5E1"
                  : "#CBD5E1",
            },
          }),
          placeholder: (provided) => ({
            ...provided,
            color: "#94A3B8",
            fontFamily: "inherit",
            fontSize: "14px",
            fontWeight: 400,
            paddingLeft: "5px",
            opacity: 1,
            lineHeight: "1.25rem",
          }),
          singleValue: (provided) => ({
            ...provided,
            color: "#111827", // text-foreground
          }),
          multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#E5E7EB",
            borderRadius: "0.375rem",
          }),
          multiValueLabel: (provided) => ({
            ...provided,
            color: "#111827",
          }),
          multiValueRemove: (provided) => ({
            ...provided,
            color: "#6B7280",
            cursor: "pointer",
            ":hover": {
              color: "#111827",
            },
          }),
          menu: (provided) => ({
            ...provided,
            backgroundColor: "#ffffff",
            borderRadius: "0.375rem",
            border: "1px solid #E2E8F0",
            zIndex: 9999,
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />

      {error && <div className="text-red-500 text-sm mt-1">{errorMsg}</div>}
    </div>
  );
};

export default SelectComponent;
